import styled from "styled-components";

const PageContainer = styled.div`
  display: flex;
  height: 100%;
`;

export { PageContainer };
